// Main page: for people driving through. A greeting and the Listen player,
// nothing else (the neighborhood pages are not linked from here).
import { setupListen } from "./live.ts";
import { $, drawLights } from "./site.ts";

document.querySelectorAll(".lights-string").forEach(drawLights);
setupListen($("#listen"));
